import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ValidationMessageService {
  constructor() {}

  getErrorMessages(errors: any): string[] {
    const errorMessages: string[] = [];

    if (errors.required) {
      /* We decided to ignore labels and just use generic messages for the time being */
      errorMessages.push('Required');
    }
    if (errors.max) {
      errorMessages.push(`Maximum value is ${errors.max.max as number}.`);
    }
    if (errors.min) {
      errorMessages.push(`Minimum value is ${errors.min.min as number}.`);
    }
    if (errors.minlength) {
      errorMessages.push(`Expected at least ${errors.minlength.requiredLength as string} characters`);
    }
    if (errors.maxlength) {
      errorMessages.push(`Expected no more than ${errors.maxlength.requiredLength as string} characters`);
    }
    if (errors.zipCode) {
      errorMessages.push(`Zip Code is not in correct format ( ${errors.zipCode.requiredFormat as string} )`);
    }
    if (errors.email) {
      errorMessages.push('Invalid email format.');
    }
    if (errors.safariDomainNotValid) {
      errorMessages.push('"safarilaw.com" domain is not allowed.');
    }
    if (errors.safariNoValueCollision) {
      errorMessages.push(errors.safariNoValueCollision.collisionMessage);
    }
    if (errors.safariRequired) {
      errorMessages.push(errors.safariRequired.message);
    }
    if (errors.noControlValueCollisionInArray) {
      errorMessages.push(errors.noControlValueCollisionInArray.collisionMessage);
    }
    if (errors.safariNoControlValueCollision) {
      errorMessages.push(errors.safariNoControlValueCollision.collisionMessage);
    }
    if (errors.safariNoDomainDifference) {
      errorMessages.push(errors.safariNoDomainDifference.collisionMessage);
    }
    if (errors.safariDateLessThan) {
      errorMessages.push(errors.safariDateLessThan.errorMessage);
    }
    if (errors.safariDateRange) {
      errorMessages.push(errors.safariDateRange.errorMessage);
    }
    if (errors.canNotSetValue) {
      errorMessages.push(errors.canNotSetValue.validationMessage);
    }
    if (errors.range) {
      errorMessages.push(`Value is not in a valid range (${errors.range.validationMessage as string}).`);
    }
    if (errors.safariCurrencyLessOrGreaterValidation) {
      errorMessages.push(errors.safariCurrencyLessOrGreaterValidation.errorMessage);
    }
    if (errors.mask) {
      if (errors.mask.requiredMask == '(000) 000-0000') {
        errorMessages.push('Invalid phone format.');
      } else if (errors.mask.requiredMask == 'SSS-SS*') {
        errorMessages.push('Invalid response id format.');
      } else {
        errorMessages.push('Invalid input format.');
      }
    }
    if (errors.invalidCharacters) {
      errorMessages.push(errors.invalidCharacters.message);
    }

    return errorMessages;
  }
}
